<template>
    <div id="clientForm" class="card">
        <div class="card-body">
            <div>
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-textbox id='clientName' width="60%" name="clientName" floatLabelType="Auto" v-model="data.clientName" placeholder="Client Name"></ejs-textbox>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist id="consultants" width="60%" name="consultants" v-model="data.consultantId" :dataSource='consultants' :fields="{text: 'name', value: 'id' }" placeholder="Consultant" popupHeight='300px' floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input" style="margin-top:auto">
                        <ejs-multiselect id='stateIds' width="60%" ref='multiStates' floatLabelType="Auto" name="stateIds" v-model='data.stateIds' :dataSource='states' :fields='fields' placeholder="Country"></ejs-multiselect>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group">
                        <ejs-dropdownlist id="coordinators" width="60%" name="coordinators" v-model="data.clientCoordinatorId" :dataSource='coordinators' :fields="{text: 'name', value: 'id' }" placeholder="Coordinator" popupHeight='300px' floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist id="fiscalYear" width="60%" name="fiscalYear" v-model="data.fiscalEndMonthId" :dataSource='fiscalYear' :fields="{text: 'name', value: 'id' }" placeholder="Fiscal Year - End Month" popupHeight='300px' floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist id="clientStatus" width="60%" name="clientStatus" v-model="data.statusId" :select='onStatusChange' :dataSource='clientStatus' :fields="{text: 'name', value: 'id' }" placeholder="Status" popupHeight='300px' floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group">
                        <ejs-textbox id='companies' v-if="data.clientId" :multiline="true" name="companies" width="60%" floatLabelType="Auto" readonly="true" v-model="data.companies" placeholder="Companies"></ejs-textbox>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group">
                        <ejs-dropdownlist id="riskManager" width="60%" name="riskManager" v-model="data.riskManagerId" :dataSource='riskManagers' :fields="{text: 'name', value: 'id' }" placeholder="Risk Manager" popupHeight='300px' floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <div id="preview">
                            <img v-if="logoUrl" :src="logoUrl" />
                        </div>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group">
                        <ejs-uploader ref="uploadObj" cssClass="uploader-width" :buttons="{browse: 'Select Client Logo'}" id='uploadLogo' class="ignore-validation" name="UploadFile" :asyncSettings="path" :uploading="addHeaders" :allowedExtensions="extensions" :success="onUploadSuccess"></ejs-uploader>
                    </div>
                </div>
            </div>
            <div class="contactsForm">
                <div tabindex="0" class="e-card">
                    <div class="e-card-header">
                        <div class="e-card-header-caption">
                            <div class="e-card-title">Contact Details</div>
                        </div>
                    </div>
                    <div class="e-card-content">
                        <ejs-grid ref='grid' :dataSource='contacts' :toolbar='toolbar' :allowPaging='true' :allowEditing="true" :actionBegin="actionBegin" :actionComplete="contactsActionComplete" :editSettings='editSettings'>
                            <e-columns>
                                <!--<e-column field='title' headerText='Title' :isPrimaryKey='true' width=100 :validationRules='{ required: true }'></e-column>-->
                                <e-column field='contactName' headerText='Contact Name' width=100 :validationRules='{ required: true }'></e-column>
                                <e-column field='phone' headerText='Phone' width=100 :validationRules='{ regex: phoneNumber }'></e-column>
                                <e-column field='mobile' headerText='Mobile' width=100 :validationRules='{ regex: phoneNumber }'></e-column>
                                <e-column field='ext' headerText='Ext' width=100 :validationRules='{ regex: extension }'></e-column>
                                <e-column field='email' headerText='Email' width=100 :validationRules='{ required: true, email: true }'></e-column>
                                <e-column field='role' headerText='Role' width=100 :validationRules='{ required: true }'></e-column>
                            </e-columns>
                        </ejs-grid>
                    </div>
                </div>
            </div>
            <div class="clientButtons">
                <div class="form-row">
                    <div class="form-group col-md-6">
                    </div>
                    <div style="text-align: right; margin-top:20px;" class="form-group col-md-6">
                        <ejs-button v-if="canSave" style="margin-right:10px" cssClass="e-primary" v-on:click.native='btnSaveClick'>Save</ejs-button>
                        <ejs-button v-on:click.native='btnBackClick'>Back</ejs-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { DropDownListPlugin, MultiSelectPlugin } from "@syncfusion/ej2-vue-dropdowns";
    import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';
    import { CheckBoxPlugin, ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import { NumericTextBoxPlugin, UploaderPlugin, TextBoxPlugin, FormValidator } from "@syncfusion/ej2-vue-inputs";
    import { DialogPlugin, DialogUtility } from '@syncfusion/ej2-vue-popups';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import SyncHelper from '../../common/syncfusion';
    import gridOptions from '../../common/gridOptions';
    import apis from '../../common/network'
    import urls from '../../common/urls';
    import authToken from '../../common/authToken';

    Vue.use(DialogPlugin);
    Vue.use(DatePickerPlugin);
    Vue.use(NumericTextBoxPlugin);
    Vue.use(DropDownListPlugin);
    Vue.use(CheckBoxPlugin);
    Vue.use(ButtonPlugin);
    Vue.use(UploaderPlugin);
    Vue.use(MultiSelectPlugin);
    Vue.use(GridPlugin);
    Vue.use(TextBoxPlugin);
    Vue.use(DialogUtility);

    export default {
        name: 'ClientsForm',
        created() {
            if (!this.$route.params.clientId) return;
            apis.protectedApi(`client/${this.$route.params.clientId}`)
                .then(response => {
                    this.data = response.data;
                    this.contacts = response.data.clientContactDetailsViewModel;
                    this.logoUrl = response.data.clientLogo;
                }).catch(e => {
                    DialogUtility.alert({
                        title: 'Alert Dialog',
                        content: e.response.data.message,
                        position: { X: 700, Y: 200 },
                        showCloseIcon: true,
                        closeOnEscape: true,
                        animationSettings: { effect: 'Zoom' },
                        zIndex: 1100
                    });
                });
        },
        data() {
            return {
                data: {},
                contacts: [],
                fields: { text: 'stateName', value: 'stateId' },
                stateIds: [],
                path: {
                    saveUrl: `${urls.apiBaseUrl}upload/logo`,
                },
                logoUrl: '',
                clientForm: '',
                extensions: '.jpg,.png',
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowEditing: true,
                    allowAdding: true,
                    allowDeleting: true,
                    mode: 'Dialog'
                },
                phoneNumber: ['^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$', "Only phone number related characters are allowed."],
                extension: ['^[0-9]*$', "Only number related characters are allowed."],
                canSave: (!this.$route.params.clientId && this.$store.state.permissions["Permissions.Client.Create"]) || (this.$route.params.clientId && this.$store.state.permissions["Permissions.Client.Update"]),
                toolbar: ['Add', 'Edit', 'Delete'],
                options: {
                    //Initialize the CustomPlacement.
                    customPlacement: function (inputElement, errorElement) {
                        inputElement = inputElement.closest('.form-group');
                        errorElement.style.width = '60%'
                        inputElement.appendChild(errorElement);
                    },
                    rules: {
                        'clientName': {
                            required: true
                        },
                        'consultants': {
                            required: true
                        },
                        'stateIds': {
                            required: true
                        },
                        'fiscalYear': {
                            required: true
                        },
                        'clientStatus': {
                            required: true
                        },
                    },
                    ignore: 'ignore-validation'
                },
                allowFiltering: true
            }
        },
        methods: {

            actionBegin(args) {

                gridOptions.actionBegin(args);




            },
            onStatusChange: function (e) {
                if (e.itemData.name == "Inactive") {

                    DialogUtility.alert({
                        title: 'Alert Dialog',
                        content: 'If client goes inactive all his companies, trading groups and contracts will be inactive!',
                        position: { X: 700, Y: 200 },
                        showCloseIcon: true,
                        closeOnEscape: true,
                        animationSettings: { effect: 'Zoom' },
                        zIndex: 1100
                    });
                }
            },
            actionComplete(args) {
                if (args.requestType == 'save') {
                    showSpinner(document.getElementById('mainSpinner'));
                    this.$refs.grid.refresh();
                }
                if (args.requestType == 'refresh') {
                    hideSpinner(document.getElementById('mainSpinner'));
                }
                
                gridOptions.actionComplete(args, this.$refs.grid);
                

            },
            contactsActionComplete(args) {

                if (args.requestType == 'save') {
                    if (args.data.clientContactDetailsId != undefined) {
                        if (args.requestType == 'save') {
                            args.rowData = args.data;

                            let index = this.contacts.findIndex(item => item.clientContactDetailsId == args.data.clientContactDetailsId);
                            this.contacts[index] = args.rowData;

                        }
                    }
                }
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    const arrayFields = ["contactName", "email", "role"]
                    arrayFields.forEach(function (item) {
                        let inputElement = args.form.elements.namedItem(item);
                        if (inputElement) {
                            let parentDiv = inputElement.closest('.e-input-group');
                            if (parentDiv) {
                                parentDiv.classList.add('required-input');
                            }
                        }
                    });
                }
            },

            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            },
            addHeaders: function (args) {
                args.currentRequest.setRequestHeader('Authorization', `Bearer ${authToken.get()}`);
            },
            onUploadSuccess: function (args) {
                var response = JSON.parse(args.e.currentTarget.response);
                if (response.imageUrl) {
                    this.logoUrl = response.imageUrl;
                }
            },
            btnSaveClick: function (e) {
                e.preventDefault();
                let formStatus = this.clientForm.validate();
                if (formStatus) {
                    if (this.data.clientId) {

                        this.data.userId = this.$store.state.loggedInUserId;
                        this.data.clientLogo = this.logoUrl;

                        showSpinner(document.getElementById('mainSpinner'));
                        apis.protectedApi.put(`client`, this.data)
                            .then(response => {
                                let message = { title: 'Success!', content: 'Client is updated successfully', cssClass: 'e-toast-success' };
                                this.$root.$emit('showToast', message);
                                this.$router.push({ name: "Clients" });
                                hideSpinner(document.getElementById('mainSpinner'));
                            }).catch(e => {
                                hideSpinner(document.getElementById('mainSpinner'));
                                DialogUtility.alert({
                                    title: 'Alert Dialog',
                                    content: e.response.data.message,
                                    position: { X: 700, Y: 200 },
                                    showCloseIcon: true,
                                    closeOnEscape: true,
                                    animationSettings: { effect: 'Zoom' },
                                    zIndex: 1100
                                });
                            });
                    } else {
                        this.data.userId = this.$store.state.loggedInUserId;
                        this.data.clientLogo = this.logoUrl;
                        showSpinner(document.getElementById('mainSpinner'));
                        this.data.clientContactDetailsViewModel = this.$refs.grid.ej2Instances.dataSource;
                        apis.protectedApi.post(`client`, this.data)
                            .then(response => {
                                let message = { title: 'Success!', content: 'Client is created successfully', cssClass: 'e-toast-success' };
                                this.$root.$emit('showToast', message);
                                this.$router.push({ name: "Clients" });
                                hideSpinner(document.getElementById('mainSpinner'));
                            }).catch(e => {
                                hideSpinner(document.getElementById('mainSpinner'));
                                DialogUtility.alert({
                                    title: 'Alert Dialog',
                                    content: e.response.data.message,
                                    position: { X: 700, Y: 200 },
                                    showCloseIcon: true,
                                    closeOnEscape: true,
                                    animationSettings: { effect: 'Zoom' },
                                    zIndex: 1100
                                });
                            });
                    }
                }
            },
            btnBackClick: function (e) {
                this.$router.push({ name: "Clients" });
            }
        },
        mounted() {

            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loading'
            });

            // defines FormValidator to validate the TimePicker
            this.clientForm = new FormValidator("#clientForm", this.options);
        },
        computed: {
            consultants: () => {
                return SyncHelper.getDataManager("utils/consultants")
            },
            coordinators: () => {
                return SyncHelper.getDataManager("utils/coordinators")
            },
            riskManagers: () => {
                return SyncHelper.getDataManager("utils/riskManagers")
            },
            states: () => {
                return SyncHelper.getDataManager("utils/states")
            },
            fiscalYear: () => {
                return SyncHelper.getDataManager("utils/months")
            },
            clientStatus: () => {
                return SyncHelper.getDataManager("utils/clientStatus")
            }
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        },
    }

</script>
<style>


    #clientForm {
        min-width: 800px;
        font-family: Arial !important;
    }

    .contactsForm {
        margin-top: 90px;
    }

    #clientForm .e-control-wrapper .e-file-select,
    .e-control-wrapper .e-file-drop {
        display: none;
    }

    #clientForm .e-upload-success {
        display: none;
    }

    #clientForm .e-upload-files {
        display: none;
    }

    #preview {
        display: flex;
        justify-content: center;
        align-items: center;
    }

        #preview img {
            max-width: 30%;
            max-height: 30%;
        }

    .e-input-group {
        height: 30px;
    }

    .e-multiselect.e-input-group, .e-multiselect.e-float-input {
        word-wrap: initial;
        height: auto;
    }

    .e-multi-line-input {
        min-height: 40px;
        height: auto;
    }

    .required-input .e-float-input.e-control-wrapper .e-float-text::after {
        content: '*';
        color: red;
        margin-left: 4px;
        font-weight: bold;
    }

    .required-input.e-float-input.e-control-wrapper .e-float-text::after {
        content: '*';
        color: red;
        margin-left: 4px;
        font-weight: bold;
    }
</style>